import { mapValues } from 'lodash';

import { RecipeMacros } from '../../../../interfaces/RecipeMacros';

/** values for the ingredient's `amount`, unrounded - callers round for display */
export const getIngredientTotals = (
  perUnit: RecipeMacros,
  amount: number,
): RecipeMacros => mapValues(perUnit, (value) => value * amount);
